import { OID } from "../../defines";
import { probability } from "../../utils/math/probability";
import { bot_ball_cancelling } from "./bot_ball_cancelling";
import { bot_ball_dfj } from "./bot_ball_dfj";
import { bot_chasing_action } from "./bot_chasing_action";
import { bot_explosion_dua } from "./bot_explosion_dua";
import { bot_explosion_duj } from "./bot_explosion_duj";
import { BotMaker } from "./BotMaker";
import { frames } from "./frames";


export function make_bot_data_firzen(): BotMaker {
  return new BotMaker(OID.Firzen).set_actions(
    // d>j
    bot_ball_dfj(50, void 0),

    // d^j
    bot_explosion_duj(250, void 0, -500, 500, 500),

    // d^j x 2
    bot_explosion_duj(250, void 0, -250, 250, 250)((c) => {
      c.action_id = 'd^j_2'
      return c;
    }),

    // ball cancell
    bot_ball_cancelling('cancel_d>j'),

    // disaster
    bot_explosion_dua(100, void 0, -700, 700, 500),

    // disaster + ...a
    bot_chasing_action('d^a+a', ['a'], void 0, probability(2, 0.1))
  ).set_frames(
    ["270", "271", "272", "273"],
    ['cancel_d>j']
  ).set_frames(
    ["243", "244", "246"],
    ['d^a+a']
  ).set_frames(
    [
      ...frames.standings,
      ...frames.walkings,
      ...frames.defends,
    ],
    [
      'd^j',
      'd^j_2',
      'd^a',
      'd>j',
    ]
  )
}

BotMaker.register(OID.Firzen, make_bot_data_firzen)